import { useTranslation } from 'react-i18next';

import { SocialCurrency, useSocialCurrencyStore } from '@/hooks/use-social-currency';

import { CasinoGame } from './use-casino-games';

const MIN_PLAY_AMOUNT = '0.20';

export const useCasinoGameInfo = (game: CasinoGame) => {
    const { t } = useTranslation(['casino_category']);
    const activeCurrency = useSocialCurrencyStore(state => state.activeCurrency);

    const maxBetEUR = game.maxBetRestriction?.maxBet?.EUR ?? game.maxBetRestriction?.defaultMaxBet?.EUR;
    const maxBetAmount = (maxBetEUR ?? 0).toFixed(2);
    const categoryName = game.categories.items[0]?.name;
    const gameType = categoryName ? t(categoryName as any, game.type) : game.type;

    const betLimits =
        activeCurrency !== SocialCurrency.COINS && maxBetEUR ? { min: MIN_PLAY_AMOUNT, max: maxBetAmount } : null;
    const betRange = betLimits ? `${betLimits.min} - ${betLimits.max}` : null;

    const gameInfoText = gameType ? `${gameType}${betRange ? `: ${betRange}` : ''}` : null;
    const rtp = game.theoreticalPayOut ? `${(game.theoreticalPayOut * 100).toFixed(2)}%` : null;
    const volatility = game.volatility || null;

    return { gameInfoText, betLimits, rtp, volatility };
};
